import { createStore, createEvent } from 'effector'

export const contactPopupStore = createStore(false)

export const openContact = createEvent()
export const closeContact = createEvent()

contactPopupStore.on(openContact, () => true)
contactPopupStore.on(closeContact, () => false)
